import { Tab } from '../../shared/tabs/tabs.model';

export const tariffsSubmenu: Tab[] = [
  {
    name: 'tariffs.title',
    url: '/main/tariffs',
  },
  {
    name: 'tariffs.subscribe.mine',
    url: '/main/subscriptions',
  },
];
